// extracted by mini-css-extract-plugin
export default {"wrapper":"Kw-z","button":"Lw-z","alternate":"Mw-z","disabled":"Nw-z","paymentWarning":"Ow-z","fadeIn":"Pw-z"};